import { BREAKPOINTS } from '../../model/model';
import { isDefined, isNotDefined } from '../../utils/util';

class NewsContent {
  constructor(options) {
    const _ = this;
    if (!options) return;
    _.option = $.extend({
      wrap: null,
      breakpoint: BREAKPOINTS,
      global: window,
      data : null
    }, options);
    _.global = (_.option.global) ? _.option.global : window;
  }

  init(obj) {
    const _ = this;
    // console.log( '# newsContent.js init() _.option : ', _.option);
    if (isDefined(_.option.wrap) && _.option.wrap.length) _.setInstance();
    return _;
  }

  setInstance() {
    const _ = this;
    // console.log( '# newsContent.js : _.option.data : ', _.option.data);
    let tmpl_item = _.option.data.items.map( (item, i) => {
      return `
        <li class="${item.flag ? `is-new-true`:`is-new-false`}"><a href="${item.url}">${item.title}</a>${item.flag ? `<span class="icon-new"></span>`:``}</li> `;
    }).join('');

    let tmpl = `
      <header><h2><a href="${_.option.data.headerUrl}">${_.option.data.header}</a></h2></header>
      <article>
          <a href="${_.option.data.url}">
            <dl><dd class="thumb" style="background-image:url('${_.option.data.thumbnail}');"><img src="${_.option.data.thumbnail}" class="thumb"></dd>
            <dt>${_.option.data.title}</dt></dl>
          </a>
          <ul>${tmpl_item}</ul>
      </article>
    `;
    _.option.wrap.append(tmpl);

  }

}

export default NewsContent;


// WEBPACK FOOTER //
// ./_src/js/main/content/NewsContent.js